import { createSimpleContext } from "@mux/ui/context"
import { dict as en } from "@/i18n/en"
import { createTranslator } from "@/i18n/translate"
import { dict as uiEn } from "@mux/ui/i18n/en"

export type Locale = "en"

const t = createTranslator({ ...en, ...uiEn })

export const { use: useLanguage, provider: LanguageProvider } = createSimpleContext({
  name: "Language",
  init: () => {
    if (typeof document === "object") document.documentElement.lang = "en"

    return {
      locale: () => "en" as Locale,
      intl: () => "en",
      t,
    }
  },
})
